module.exports = __webpack_public_path__ + "static/media/tt.d4f9a958.svg";